import { captureException } from '@sentry/react';
import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory } from 'react-router';

import { FeatureFlag } from 'src/shared/constants';
import { useProfileQuery } from 'src/shared/graphql/generated';
import { useAuthExperience } from 'src/shared/hooks/useAuthExperience';
import { External, Route as Routes } from 'src/shared/route';

const Router = () => {
  const { data: profileData } = useProfileQuery();
  const { authed, user, splitClient } = useAuthExperience();
  const history = useHistory();

  const [shouldSeeNewJobsPage, setShouldSeeNewJobsPage] = useState<
    boolean | null
  >(null);

  useEffect(() => {
    if (!profileData) return;
    // This is necessary because we need to be asking for treatments from the client after it has been updated with the user's attributes
    // TODO: remove when we no longer initialize Split with anonymized key
    const getTreatments = async () => {
      const authedSplitClient = await splitClient;

      const isJobsPageEnabledTreatment = authedSplitClient.getTreatment(
        FeatureFlag.Web.JOBS_PAGE as string,
        {
          orgCreatedAt: profileData?.profile?.user?.orgs?.[0]?.createdAt
            ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion, @typescript-eslint/no-unsafe-argument
              new Date(profileData?.profile.user.orgs[0].createdAt).getTime()
            : '',
          kind: profileData?.profile.user.orgs.some(
            userOrg => userOrg?.partner?.kind === 'INSURANCE',
          )
            ? 'INSURANCE'
            : 'STANDARD',
          isManaged: !!profileData?.profile?.user?.orgs?.[0]?.isManaged,
        },
      );

      return {
        isJobsPageEnabledTreatment,
      };
    };

    if (authed) {
      getTreatments()
        .then(({ isJobsPageEnabledTreatment }) => {
          setShouldSeeNewJobsPage(isJobsPageEnabledTreatment === 'on');
        })
        .catch(error => {
          captureException(error);
        });
    }
  }, [authed, splitClient, user, profileData]);

  useEffect(() => {
    if (shouldSeeNewJobsPage === null) return; // if it's null, meaning it's not been set based on Split, do nothing

    if (shouldSeeNewJobsPage) {
      history.push(`${Routes.PROPERTIES.path}${location.search}`);
    } else {
      window.location.href = External.START.path;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldSeeNewJobsPage]);

  return (
    <Switch>
      <Route exact path={Routes.START_WITH_REDIRECT.path} />
    </Switch>
  );
};
export { Router };
